module.exports = __webpack_public_path__ + "static/img/biaoshiContent.b0e1754.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/biaoshiContent.png
// module id = aKS9
// module chunks = 0